import React, { useState } from 'react';
import { Card, Form, Select, Button, Slider, Row, Col, Statistic, message, Spin, Divider } from 'antd';
import { PlayCircleOutlined, CloudUploadOutlined } from '@ant-design/icons';
// 引入Plotly绘图库
import Plot from 'react-plotly.js';

const CarbonEstimationModule = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleRun = () => {
    setLoading(true);
    // 模拟计算过程
    setTimeout(() => {
      setLoading(false);
      setResult({
        total: 12500.45,
        mean: 85.3,
        r2: 0.92,
        chartData: [80, 82, 85, 84, 88, 90, 92] // 模拟时间序列数据
      });
      message.success('估算完成！');
    }, 2000);
  };

  return (
    <div style={{ padding: 24 }}>
      <Row gutter={24}>
        <Col span={8}>
          <Card title="参数配置">
            <Form layout="vertical">
              <Form.Item label="选择算法">
                <Select defaultValue="rf">
                  <Select.Option value="rf">随机森林回归</Select.Option>
                  <Select.Option value="svr">支持向量机</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item label="树的数量 (n_estimators)">
                <Slider min={10} max={500} defaultValue={100} />
              </Form.Item>
              <Form.Item label="最大深度 (max_depth)">
                <Slider min={1} max={20} defaultValue={10} />
              </Form.Item>
              <Form.Item label="遥感数据源">
                <Button icon={<CloudUploadOutlined />} block>上传TIFF影像</Button>
              </Form.Item>
              <Button type="primary" icon={<PlayCircleOutlined />} block onClick={handleRun} loading={loading}>
                开始估算
              </Button>
            </Form>
          </Card>
        </Col>
        <Col span={16}>
          <Card title="估算结果展示">
            {loading ? <div style={{textAlign: 'center', padding: 50}}><Spin size="large" tip="正在进行反演计算..." /></div> : 
             result ? (
              <div>
                <Row gutter={16} style={{textAlign: 'center'}}>
                  <Col span={8}><Statistic title="总碳储量 (吨)" value={result.total} precision={2} /></Col>
                  <Col span={8}><Statistic title="平均密度 (t/ha)" value={result.mean} /></Col>
                  <Col span={8}><Statistic title="R² (拟合优度)" value={result.r2} valueStyle={{ color: '#3f8600' }} /></Col>
                </Row>
                <Divider />
                <h4>碳储量时间序列变化趋势</h4>
                <Plot
                  data={[{
                    x: ['2018', '2019', '2020', '2021', '2022', '2023', '2024'],
                    y: result.chartData,
                    type: 'scatter',
                    mode: 'lines+markers',
                    marker: {color: '#1890ff'},
                  }]}
                  layout={{width: '100%', height: 300, margin: {t: 20, b: 40, l: 40, r: 20}}}
                  style={{width: '100%'}}
                />
              </div>
            ) : <div style={{textAlign: 'center', color: '#999', padding: 50}}>请在左侧配置参数并运行模型</div>}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CarbonEstimationModule;